/**
 * IIFE to isolate the scope
 */
var raymont = (function(){

    return {};  

})();                     